import { api } from '../../../system/api';

export default {
    login: (params) => api.get('login', { params }),
    user: () => api.get('auth/user'),
    register: (data) => api.post('/merchant/register', data),
    balance: () => api.get('merchant/balance'),
    banner: (code) => api.get(`tenants/${code}/images`),
};
